
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/password/new",
      function () {
        return require("private-next-pages/a/password/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/password/new"])
      });
    }
  